import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';

import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AccountBox from '@mui/icons-material/AccountBox';
import Transform from '@mui/icons-material/Transform';
import ViewComfy from '@mui/icons-material/ViewComfy';
import ExitToApp from '@mui/icons-material/ExitToApp';
import ExtensionIcon from '@mui/icons-material/Extension';

import { capitalize } from 'helpers/helpers';
import { MenuHeaderItem } from './MenuHeaderItem';
import { useIsSupportUser } from 'hooks/user';

/**
 * Side bar menu, opened with the settings icon, that contains less frequently used links.
 */
const SettingsMenu = (props: {
    logout: () => void;
    isAdmin: boolean;
}): React.ReactElement => {
    const { t } = useTranslation();

    const isSupportUser = useIsSupportUser();

    return (
        <Paper>
            {props.isAdmin && (
                <MenuHeaderItem
                    key="integrations"
                    to="/integrations"
                    icon={<ExtensionIcon />}
                    text={capitalize(t('header.integrations'))}
                />
            )}
            <MenuHeaderItem
                icon={<ViewComfy />}
                text={t('header.dataDetails')}
                to="/cellar"
            />
            <MenuHeaderItem
                to="/mappings"
                icon={<Transform />}
                text={t('header.mappingTables')}
            />
            <Divider key="divider_1" />
            {(props.isAdmin || isSupportUser) && (
                <MenuHeaderItem
                    icon={<SupervisorAccountIcon />}
                    text={t('header.admin')}
                    to="/admin/users"
                />
            )}
            <MenuHeaderItem
                icon={<AccountBox />}
                text={t('header.profile')}
                to="/profile"
            />
            <Divider key="divider_2" />
            <MenuHeaderItem
                className="e2e-logout-button"
                icon={<ExitToApp />}
                text={t('header.logout')}
                onClick={props.logout}
            />
        </Paper>
    );
};

export { SettingsMenu };
